<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">15</h2>
<p class="vers"><span>Hier bin</span> ich, dir Lieder
zu singen.<br class="calibre1"/>
In deiner Halle hab ich den Sitz im Winkel.</p>
<p class="vers">In deiner Welt hab ich kein Werk zu<br class="calibre1"/>
tun, mein nutzlos Leben kann nur ausströmen<br class="calibre1"/>
zwecklos in Tönen.</p>
<p class="vers">Wenn die Stunde schlägt für deinen<br class="calibre1"/>
schweigenden Dienst im dunkeln Tempel<br class="calibre1"/>
der Mitternacht, befiehl mir, mein<br class="calibre1"/>
Meister, vor dir zu stehn und zu singen.</p>
<p class="vers">Wenn in der Morgenluft die goldene<br class="calibre1"/>
Harfe gestimmt ist, ehre mich und befiehl<br class="calibre1"/>
mir, vor dich zu treten. <a id="page20" title="Wunibald/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0016.vue?cd3cdba8